import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import MoneyText from '../../Text/Currency/MoneyText'
import { multiplyRate } from '../../../helpers/numberHelper'
import { TravelMutationDto, TravelOverviewDto } from '../../../config/registrationConfig'
import ModifyRegistrationRow, {
    ModifyRegistrationColumnProps,
    ModifyRegistrationColumns,
    ModifyRegistrationRowProps,
    useRegistrationRowStyles,
} from '../Registration/ModifyRegistrationRow'
import { TravelListProps } from './TravelList'
import { Input, InputProps } from '@fluentui/react-components'
import FormikField from '../../Formik/FormikField'

type Props = ModifyRegistrationRowProps<TravelOverviewDto, TravelMutationDto, TravelListProps>
type ColumnProps = ModifyRegistrationColumnProps<TravelListProps>

function Columns(props: ColumnProps): ReactElement {
    const styles = useRegistrationRowStyles()
    const { values } = useFormikContext<TravelMutationDto>()

    switch (props.column.key) {
        case 'distance':
            return (
                <FormikField<InputProps, TravelMutationDto>
                    fieldName={'distance'}
                    component={Input}
                    componentProps={{
                        contentAfter: 'km',
                        size: 'small',
                        className: styles.rate,
                        input: { className: styles.rateInput },
                    }}
                />
            )
        case 'subtotal':
            return (
                <MoneyText
                    value={multiplyRate(values.distance, { amount: values.rate, currency: props.file.currency })}
                />
            )
    }
    return <ModifyRegistrationColumns<TravelMutationDto, TravelListProps> {...props} />
}

export default function ModifyTravelRow(props: Props): ReactElement {
    return <ModifyRegistrationRow<TravelOverviewDto, TravelMutationDto, TravelListProps> {...props} columns={Columns} />
}
